var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.categories)?_c('one-new-mobile-menu',{attrs:{"open":_vm.isActiveMenu,"menu-model":_vm.menuModel},on:{"close":function($event){return _vm.$emit('close')}}},[_c('template',{slot:"footer"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }